import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { BadRequestComponent } from './components/bad-request/bad-request.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { InternalServerErrorComponent } from './components/internal-server-error/internal-server-error.component';
import { AppStates } from './routing/app.states';
import { ErrorModule } from "@nx/error";
import { MonoCommonModule } from '@nx/mono-common';

@NgModule({
  imports: [
    CommonModule,
    MonoCommonModule,
    ErrorModule,
    RouterModule.forChild([...AppStates])
  ],
  declarations: [NotFoundComponent, BadRequestComponent, ForbiddenComponent, UnauthorizedComponent, InternalServerErrorComponent]
})
export class LmwErrorModule {}
